import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import './About.css';

const pillars = [
  {
    num: '01',
    title: 'Open-Source Intelligence',
    body: 'Systematic collection, correlation, and evaluation of intelligence from open and appropriate sources to inform strategic decisions at every level of your organization.',
  },
  {
    num: '02',
    title: 'Multidisciplinary Mission Centers',
    body: 'Specialized centers led by senior analysts, addressing high-priority issues: nonproliferation, counterterrorism, counterintelligence, organized crime, narcotics, and arms control.',
  },
  {
    num: '03',
    title: 'R&D Partnerships',
    body: 'Collaborative research and development with the broader Intelligence Community, advancing analytic capabilities and intelligence software solutions for the modern threat landscape.',
  },
  {
    num: '04',
    title: 'Youth & Professional Development',
    body: 'Professional intelligence development, open to all — providing overall direction and coordination to aid and promote the next generation of security and intelligence professionals.',
  },
];

export default function About() {
  const leftRef = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <section id="about" className="about-section">
      <div className="section-label">Who We Are</div>
      <div className="about-grid">
        <div className="about-left fade-in" ref={leftRef}>
          <h2 className="section-title" style={{ color: 'var(--ink)' }}>
            Not just analysis —<br />
            <em style={{ color: 'var(--gold-dark)' }}>decisive intelligence.</em>
          </h2>
          <blockquote className="about-quote">
            "We contribute to the greater Intelligence Community by managing services of common
            concern — while partnering on research and development."
          </blockquote>
          <p className="about-body">
            Grantsman specializes in software solutions and services, providing intelligence and
            analytic capabilities within the Security Industry. We conduct rigorous intelligence
            gathering and audits through open sources and other appropriate means — always within
            legal and ethical boundaries.
          </p>
          <p className="about-body">
            We correlate and evaluate intelligence related to business operations in strict
            accordance with local and international regulations, giving our clients the clarity
            needed to act decisively in uncertain environments. Grantsman holds no police,
            subpoena, or law enforcement powers — our strength lies entirely in analytical
            excellence.
          </p>
        </div>

        <div className="about-right fade-in delay-2" ref={rightRef}>
          <div className="about-pillars">
            {pillars.map((p) => (
              <div className="pillar" key={p.num}>
                <div className="pillar-num">{p.num}</div>
                <div className="pillar-content">
                  <h4>{p.title}</h4>
                  <p>{p.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
